var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CcDownload',{attrs:{"data":_vm.data,"show-content":false,"show-logo":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }